import { render, staticRenderFns } from "./we-series-view.vue?vue&type=template&id=71a6f6b9&scoped=true&"
import script from "./we-series-view.vue?vue&type=script&lang=js&"
export * from "./we-series-view.vue?vue&type=script&lang=js&"
import style0 from "./we-series-view.vue?vue&type=style&index=0&id=71a6f6b9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6f6b9",
  null
  
)

export default component.exports